module.exports = "mutation SendMagicLink($email: String!) {\n  sendMagicLink(email: $email) {\n    success\n    message\n  }\n}\n"